module.exports = __webpack_public_path__ + "img/big_1_16.a340f404.png";